<template>
  <!--去看看单个商品组件（纵向排序）-->
  <tk-flex
    @click.native="$push({ path: '/commodity/productDetails', query: { id: commodity.objectId } })"
    class="full-width"
  >
    <div>
      <div
        class="commodity-look-image class-recommended-img"
        :style="{width: width + 'px', height: height + 'px'}"
      >
        <tk-image class="class-recommended-image" :src="commodity.showPictures[0]" :width="width" :height="height"></tk-image>
        <div class="commodity-look-image-decoration" v-if="isRecommend">推荐</div>
      </div>
    </div>
    <tk-flex
      column
      style="position: relative;align-self: stretch;"
      class="m-l-15 van-flex-row p-t-5 full-width"
    >
      <tk-flex
        middle
        class="full-width"
      >
        <div
          style="width: 35px;flex-shrink:0;"
        >
          <tk-flex
            center
            v-if="commodity.selfAndSelected"
            style="line-height: 17px;"
            class="commodity-title-label">
            <div>
              {{commodity.selfAndSelected | titleLabel}}
            </div>
          </tk-flex>
        </div>
        <div class="font-14 van-ellipsis">{{commodity.productTitle}}</div>
      </tk-flex>
      <!--卖点-->
      <div
        class="class-card-selling van-ellipsis m-t-2"
        v-if="sellingShow"
      >
        {{commodity.selling}}
      </div>
      <slot name="sales"></slot>
      <!--抢购进度-->
      <tk-flex
        middle
        class="caption m-t-2"
        style="line-height: 1;"
        v-if="isRecommend">
        <div>已抢{{percentage}}%</div>
        <load-progress
          :percent="percentage" :duration="500" :progress-show="true"
          :type="'rect'" :path-colors="['rgba(243, 243, 243, 1)', 'rgba(255, 198, 198, 1)']"
          :text-color="'rgba(255, 255, 255, 0)'"
          :rect-height="10"
          class="m-l-5 p-t-5"
          :rect-width="100"
        ></load-progress>
      </tk-flex>
      <tk-flex
        v-else
        style="line-height: 1;"
        class="caption m-t-10"
      >
        <div>已抢{{percentage}}%</div>
        <load-progress
          :percent="percentage" :duration="500" :progress-show="true"
          :type="'rect'" :path-colors="['rgba(243, 243, 243, 1)', 'rgba(255, 198, 198, 1)']"
          :text-color="'rgba(255, 255, 255, 0)'"
          :rect-height="10"
          :rect-width="100"
          class="m-l-5 p-t-2"
        ></load-progress>
      </tk-flex>
      <tk-flex
        between
        bottom
        style="position: absolute;
        bottom: 5px;width: 100%;"
      >
        <div class="full">
          <div v-if="commodity.oldPrice">
            <div class="class-card-red">
              <span class="font-10">￥</span>{{commodity.price}}<span class="font-12 m-l-10 class-card-decoration caption">
                <span class="font-10">￥</span>{{commodity.oldPrice}}</span>
            </div>
          </div>
          <div v-else>
            <div class="class-card-red">
              <span class="font-10">￥</span>{{commodity.price}}<span class="m-l-10" style="width: 100%;height: 18px;"></span>
            </div>
          </div>
        </div>
        <tkui-button
          :disabled="isNothing"
          class="small primary rounded raised class-card-look"
        >
          {{!isNothing ? '马上抢' : '已抢光'}}
        </tkui-button>
      </tk-flex>
    </tk-flex>
    <slot name="tips"></slot>
  </tk-flex>
</template>

<script>
import loadProgress from '@/components/loadProgress'
export default {
  data () {
    return {
      panicBuying: null
    }
  },
  components: {
    loadProgress
  },
  filters: {
    titleLabel (val) {
      return val === 'self' ? '自营' : '精选'
    }
  },
  computed: {
    // 计算百分比
    percentage () {
      if (!this.commodity) { return 0 }
      let obj = this.$tkHelper.deepClone(this.commodity)
      if (!obj.sales) { return 0 }
      if (!obj.snappingInventory || !obj.snappingSales) { return 0 }
      let num = obj.snappingSales / obj.snappingInventory
      let percent = Number(Number(num * 100).toFixed(2))
      if (percent > 99.99) { percent = 100 }
      return percent
    },
    isNothing () {
      return this.percentage >= 100
    }
  },
  props: {
    commodity: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    sellingShow: {
      type: Boolean,
      required: true
    },
    isRecommend: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .class-card-red { /*颜色及文本修饰*/
    color: rgba(250, 51, 51, 1);
  }
  /*图片样式*/
  .commodity-look-image {
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }
  /*卖点样式*/
  .class-card-selling {
    min-height: 18px;
    border-radius: 2px;
    padding: 3px 0;
    font-size: 12px;
  }
  /*马上抢按钮样式*/
  .class-card-look {
    min-width: 60px;
    margin: 0;
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
    background:linear-gradient(90deg,rgba(255,56,67,1),rgba(254,102,0,1));
  }
  .commodity-look-image-decoration {
    position: absolute;
    top: 0;
    left: 0;
    width: 35px;
    height: 20px;
    text-align: center;
    background:linear-gradient(90deg,rgba(255,56,67,1),rgba(254,102,0,1));
    font-size: 12px;
    border-radius:0 0 6px 0;
    color: rgba(254, 254, 254, 1);
  }
</style>
